import React from "react";
import { typeShell } from "../styles/typeShell";

const TYPE_ICON = {
    info: (
        <svg className="size-icon-control shrink-0 text-accent" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><rect x="9" y="8" width="2" height="6" rx="1" fill="currentColor" /><rect x="9" y="5" width="2" height="2" rx="1" fill="currentColor" /></svg>
    ),
    success: (
        <svg className="size-icon-control shrink-0 text-success" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><path d="M6 11l3 3 5-5" stroke="currentColor" strokeWidth="2" fill="none" /></svg>
    ),
    warning: (
        <svg className="size-icon-control shrink-0 text-warning" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><rect x="9" y="6" width="2" height="6" rx="1" fill="currentColor" /><rect x="9" y="14" width="2" height="2" rx="1" fill="currentColor" /></svg>
    ),
    danger: (
        <svg className="size-icon-control shrink-0 text-error" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><rect x="9" y="6" width="2" height="6" rx="1" fill="currentColor" /><rect x="9" y="14" width="2" height="2" rx="1" fill="currentColor" /></svg>
    ),
};

const TYPE_CLASS = {
    info: "border-l-accent bg-accent-10 text-accent-hover",
    success: "border-l-success bg-success-10 text-success",
    warning: "border-l-warning bg-warning-10 text-warning",
    danger: "border-l-error bg-error-10 text-error",
};

function Alert({ type = "info", message, onClose, isVisible = true, duration = 0 }) {
    React.useEffect(() => {
        if (isVisible && duration > 0) {
            const timer = setTimeout(() => {
                onClose && onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [isVisible, duration, onClose]);

    if (!isVisible) return null;

    const typeClass = TYPE_CLASS[type] || TYPE_CLASS.info;

    return (
        <div
            className={`relative my-4 flex min-w-[280px] max-w-[480px] items-center gap-3 border-l-[5px] border-solid bg-surface px-6 py-4 shadow-none ${typeShell.bodyMedium} ${typeClass}`}
            role="alert"
        >
            <span className="mr-2 flex items-center">{TYPE_ICON[type]}</span>
            <span className="flex-1">{message}</span>
            {onClose && (
                <button
                    className="cursor-pointer rounded border-none bg-transparent px-2 py-1 text-xl font-bold text-text-hint transition-colors hover:bg-border-subtle"
                    onClick={onClose}
                    aria-label="閉じる"
                    type="button"
                >
                    <span className="material-symbols-outlined text-icon-control">
                        close
                    </span>
                </button>
            )}
        </div>
    );
}

export default Alert;
